import isEqual from 'date-fns/is_equal'

export default function isRangeEqual(first, second) {
  if (!first) return false
  return isEqual(first.start, second.start) && isEqual(first.end, second.end)
}



// WEBPACK FOOTER //
// ./client/utils/isRangeEqual.js